<div class="search-input-container group relative flex h-14 items-center gap-1 overflow-hidden rounded-full bg-[var(--surface-container-high-color)] p-1">
  <div class="search-input-leading flex h-12 w-12 shrink-0 items-center justify-center" aria-hidden="true">
    <mat-icon class="search-input-icon text-onSurfaceVariant">search</mat-icon>
  </div>
  <label class="relative min-w-0 flex-1" [attr.for]="'dtis-search-input-' + label()">
    <span class="sr-only">{{ label() }}</span>
    @if (!value()) {
    <span
      class="search-input-placeholder pointer-events-none absolute inset-x-1 top-1/2 z-0 -translate-y-1/2 truncate text-body-large text-onSurfaceVariant"
      aria-hidden="true"
    >
      {{ placeholder() }}
    </span>
    }
    <input
      class="search-input-field relative z-10 h-12 w-full bg-transparent px-1 text-body-large text-onSurface outline-none"
      [id]="'dtis-search-input-' + label()"
      type="text"
      inputmode="search"
      [value]="value()"
      [title]="label()"
      (input)="onInput($event)"
    >
  </label>
  @if (value()) {
  <button
    type="button"
    class="search-input-clear relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-onSurfaceVariant hover:bg-onSurface/8 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    [attr.aria-label]="'Clear ' + label()"
    [title]="'Clear ' + label()"
    (click)="clear()"
  >
    <mat-icon class="search-input-icon" aria-hidden="true">close</mat-icon>
  </button>
  }
  <div
    class="pointer-events-none absolute inset-0 bg-hoverOverlay opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:bg-onSurface/10 group-focus-within:opacity-100 group-active:bg-onSurface/10 group-active:opacity-100"
    aria-hidden="true"
  ></div>
</div>
